// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".international-map-wrap{margin-top:-1.6rem}.bubble-box{margin-top:1.6rem}.legend-ul{display:block;margin-top:20em}.legend-li{float:left;padding-right:4em}", ""]);
// Exports
module.exports = exports;
